<template>
    <div class="page">
        <div class="information_box">
            <template  v-if="pkgImg1&&pkgImg1.length>2">
                <img :src= "pkgImg1"  alt="" class="top_icon">
            </template>
            <template v-else>
                <img src="@/assets/20250108220008.jpg" alt="" class="top_icon">
            </template>
             <div class="btn" @click="sumbitItem">￥{{ setObj.salePriceRmb }}立即激活</div>
        </div>
        <div class="container_box">
            <div class="container_main">
                <div class="container_item" v-for="(item, index) in dataList" :key="index"
                    :class="[index === inx ? 'container_item_active' : '']" @click="changeItem(item, index)">
                    <div class="price_item">月均{{ item.tuiJun }}元</div>
                    <div class="liuliang"> {{ item.packageName }} </div>
                    <div class="yang_item">
                        ￥<span class="item_pric">{{ item.salePriceRmb }} </span>/{{ item.tuiRemark }}
                    </div>
                    <img src="@/assets/333.png" v-if="index === inx" alt="" class="choose_icon">
                </div>

            </div>
           
        </div>

        <div class="zxkf" style="" @click="cust">
            <img src="@/assets/userNew/icon3.png" style="width:22px;height: 22px;margin-top:4px;">
            <div class="zxkf-btn">联系客服</div>
        </div>

    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            pkgImg1:'',
            pkgImg2: '',

            kefuUrl: localStorage.getItem("kefuUrl"),
            shebeiLogin: localStorage.getItem("shebeiLogin"),
            dataList: [],
            inx: 0,
            isNextMonth: '0',
            isAdmin: '',
            setObj: {}
        }
    },
    beforeCreate() {
        const screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
        document.querySelector('html').setAttribute('style', `font-size:${screenWidth / 10}px`)
    },
    beforeDestroy() {
        // 组件销毁前移除监听
        document.querySelector('html').setAttribute('style', '')
    },
    created() { 
        var pkgImg1= localStorage.getItem("pkgImg1")
        if(pkgImg1&&pkgImg1.length>2){
            this.pkgImg1=  "http://qd.10086.hi.cn:8888/" + localStorage.getItem("pkgImg1")
            this.pkgImg2=  "http://qd.10086.hi.cn:8888/" + localStorage.getItem("pkgImg2")
        }
        var data = {
             iccid: localStorage.getItem("iccid")
           // iccid: '88888888888888887777'
        }
        this.dataList = []
        wxRequest("sim/user/soldPkg", data, "get").then(res => {
            if (res.data.code === '200') {
                this.dataList = res.data.data.list.filter(item => item.isTui === 1)
                this.dataList.sort((a,b) => b.sort - a.sort)
                this.isAdmin = res.data.data.isAdmin
                this.setObj = this.dataList[0]
            }
        })
    },
    methods: {
        //联系客服
        cust() {
            Dialog.confirm({
                title: '联系客服',
                message: '点击确定跳转人工客服',
            }).then(() => {
                window.location.href = this.kefuUrl;
            }).catch(() => {
                // on cancel
            });
        },

        changeItem(data, index) {
            this.inx = index
            this.setObj = data
        },
        async sumbitItem() {
            var params = {
                iccid: localStorage.getItem("iccid"),
                soldPackageId: this.setObj.id,
                isNextMonth: 0,
                isAdmin: this.isAdmin
            }
            var postUrl = "order/pkgOrder/add";
            let postPayType = 20;
            await wxRequest("sim/get/pay/state/price", { iccid: localStorage.getItem("iccid") }, "post").then((res) => {
                if (res.data.code != 400) {
                    //查询是什么支付类型
                    if (res.data.code == 562) {
                        postUrl = "order/yyPkgOrder/add/pkg";
                        postPayType = 62;
                    }
                }
            });
            let formData = new FormData();
            Object.keys(params).forEach((key) => {
                formData.append(key, params[key]);
            });
            await wxRequest(postUrl, formData, "post").then(res => {
                if (res.data.code == 200) {
                    if (postPayType == 20) {
                        //微信第三方
                        var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    this.onBridgeReady,
                                    false
                                );
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent(
                                    "onWeixinJSBridgeReady",
                                    this.onBridgeReady
                                );
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (postPayType == 62) {
                        window.location.href = res.data.data;
                    } else {
                        Dialog.alert({ message: '暂不支持的支付通道！' });
                    }
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            })
        },

        //流量套餐充值时唤起微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router
                        .push({
                            path: "/user/home",
                            query: {
                                iccid: _this.$store.state.iccid,
                            },
                        })
                        .catch(() => { });

                }
            });
        },
    }

}
</script>
<style lang="less" scoped>
/* 设置基础字体大小 */
:root {
    font-size: 16px;
}

html {
    font-size: 39px;
}

.information_box {
    display: flex;
    flex-direction: column;
    /* background: #d5e1ff; */
    position: relative;
    .top_icon {
        width: 100%;
        height: 100%;
    }
}

.zxkf {
    width: 40px;
    height: 100px;
    position: fixed;
    border-radius: 25px;
    right: 6px;
    bottom: 350px;
    text-align: center;
    background: #EAF2FF;

    .zxkf-btn {
        font-size: 14px;
        color: #397EF5;
        line-height: 15px;
        margin: 0 8px;
        margin-top: 6px;
    }
}

.container_box {
    position: absolute;
    top: 6.88rem;
    width: 100%;


    .container_main {
        display: flex;
        flex-wrap: wrap;
        margin: 0 .82667rem;
        align-items: center;
        justify-content: space-between;

        .container_item {
            width: 4.02667rem;
            height: 3.30667rem;
            text-align: center;
            background: #ecf7ff;
            border-radius: .21333rem;
            position: relative;
            margin-bottom: .26667rem;

            .price_item {
                width: 1.81333rem;
                height: .58667rem;
                border-radius: .21333rem .21333rem .21333rem 0;
                background: #fedad6;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: .32rem;
                color: #e83529;
                text-align: center;
                line-height: .58667rem;
                margin: .42667rem 1.12rem 0;
            }

            .liuliang,
            .yang_item {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: .48rem;
                font-style: normal;
                line-height: .66667rem;
            }

            .liuliang {
                color: #8a4315;
                height: .66667rem;
                margin-top: .13333rem;
            }

            .yang_item {
                height: 1.28rem;
                color: #ff654c;
                text-align: center;
                margin-top: .18667rem;
            }
        }

        .container_item_active {
            width: 4.02667rem;
            height: 3.30667rem;
            background: #fff;
            border: .02667rem solid #ff654c;
            margin-bottom: .26667rem;
        }

        .choose_icon {
            width: .85333rem;
            height: .48rem;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

    
}
.page{
    // padding-bottom: 10px;
    height: 100vh;
}
.btn {
    background: url('~@/assets/0dd678f2.png') no-repeat;
    background-size: 100% 100%;
    width: 5.93333rem;
    height: 1.2rem;
    line-height: 1.2rem;
    text-align: center;
    font-family: AlimamaShuHeiTi;
    font-weight: 700;
    font-size: .53333rem;
    color: #fff;
    margin: 0 auto;
    margin-bottom: 10px;
    position: absolute;
    top: 31%;
    left: 0;
    right: 0;
}
</style>
